import Locize from 'i18next-locize-backend'
import i18n from 'i18next'

const locizeBackend = new Locize({
    projectId: process.env.I18N_LOCIZE_PROJECT_ID,
    apiKey: process.env.I18N_LOCIZE_API_KEY,
    referenceLng: process.env.I18N_LOCALE,
})

const storage = {
    setItem(key, value) {
        if (window.localStorage) {
            try {
                window.localStorage.setItem(key, value)
            } catch (e) {
                // f.log('failed to set value for key "' + key + '" to localStorage.');
            }
        }
    },
    getItem(key, value) {
        if (window.localStorage) {
            try {
                return window.localStorage.getItem(key, value)
            } catch (e) {
                // f.log('failed to get value for key "' + key + '" from localStorage.');
            }
        }
        return undefined
    },
}

function getDefaults() {
    return {
        prefix: 'i18next_res_',
        versions: {},
    }
}

class Cache {
    constructor(services, options = {}) {
        this.init(services, options)
        this.type = 'backend'
    }

    init(services, options = {}) {
        this.services = services
        this.options = {
            ...options,
            ...getDefaults(),
        }
    }

    read(language, namespace, callback) {
        if (!window.localStorage) {
            return callback(null, null)
        }

        let local = storage.getItem(`${this.options.prefix}${language}-${namespace}`)

        if (local) {
            local = JSON.parse(local)
            if (
                // there should be no language version set, or if it is, it should match the one in translation
                this.options.versions[language] === local.i18nVersion
            ) {
                delete local.i18nVersion
                delete local.i18nStamp

                this.invalidateCache(language, namespace, local)

                return callback(null, local)
            }
        }

        callback(null, null)
    }

    save(language, namespace, data) {
        if (window.localStorage) {
            data.i18nStamp = new Date().getTime()

            // language version (if set)
            if (this.options.versions[language]) {
                data.i18nVersion = this.options.versions[language]
            }

            // save
            storage.setItem(`${this.options.prefix}${language}-${namespace}`, JSON.stringify(data))
        }
    }

    invalidateCache(language, namespace, prevData) {
        setTimeout(() => {
            // Spawn loading of resources from original source - and update
            locizeBackend.read(language, namespace, (err, data) => {
                if (data && JSON.stringify(data) !== JSON.stringify(prevData)) {
                    // We got updates from locize, update cache
                    this.save(language, namespace, data)

                    // Update resource in i18next as well
                    i18n.addResourceBundle(language, namespace, data)
                }
            })
        }, 5000)
    }
}

Cache.type = 'backend'

export default Cache
